module.exports = __webpack_public_path__ + "img/warning-3.d590dd40.png";